import styled from 'styled-components'

export default styled.section`
  align-items: center;
  background: #304760;
  display: flex;
  padding: 1em 0;
  color: #fff;

  .address {
    margin-bottom: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/Footer.js